interface InspectionKpiCardProps {
  value: number;
  label: string;
  icon: string;
  color: string;
  onClick?: () => void;
}

function formatNumber(n: number): string {
  if (n >= 1000) {
    const k = n / 1000;
    return k % 1 === 0 ? `${k.toFixed(0)}.${String(n).slice(-3, -2) || '0'}${String(n).slice(-2, -1) || '0'}${String(n).slice(-1) || '0'}`.replace(/^(\d+)\.(\d)/, '$1.$2') : n.toLocaleString('pt-BR');
  }
  return n.toLocaleString('pt-BR');
}

// Simpler formatter
function fmt(n: number): string {
  if (n >= 1000) {
    const s = n.toString();
    const i = s.length - 3;
    return s.slice(0, i) + '.' + s.slice(i);
  }
  return n.toString();
}

export default function InspectionKpiCard({ value, label, icon, color, onClick }: InspectionKpiCardProps) {
  const colorMap: Record<string, string> = {
    primary: "bg-primary-50 border-primary-200/70",
    accent: "bg-accent-50 border-accent-200/70",
    warning: "bg-warning-50 border-warning-200/70",
    danger: "bg-danger-50 border-danger-200/70",
    caution: "bg-caution-50 border-caution-200/70",
    secondary: "bg-secondary-50 border-secondary-200/70",
  };

  const iconColorMap: Record<string, string> = {
    primary: "text-primary-500",
    accent: "text-accent-500",
    warning: "text-warning-500",
    danger: "text-danger-500",
    caution: "text-caution-500",
    secondary: "text-secondary-500",
  };

  return (
    <div
      className={`rounded-xl border p-4 transition-colors duration-150 ${colorMap[color] || colorMap.primary} ${onClick ? "cursor-pointer hover:brightness-95" : ""}`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between">
        <div>
          <span className="text-2xl font-bold text-foreground-900 font-heading tracking-tight">
            {fmt(value)}
          </span>
          <p className="text-xs text-foreground-600 mt-1 leading-tight">{label}</p>
        </div>
        <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${iconColorMap[color] || iconColorMap.primary} bg-white/70`}>
          <i className={`${icon} text-lg`}></i>
        </div>
      </div>
    </div>
  );
}